<app-main-header></app-main-header>
<div class="main-content" #conteudo>
    <router-outlet></router-outlet>
    <app-avaliacao-atendimento></app-avaliacao-atendimento>
</div>
<app-main-footer></app-main-footer>
<app-acessibilidade></app-acessibilidade>
<app-tema></app-tema>
<app-aceite-cookies></app-aceite-cookies>